import React, { Component } from 'react';
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import { Category } from "../../../classes/types/category/category";
import { CategoryHandler } from "../../../classes/methods/categoryMethods/categoryMethods";
import { Card, CircularProgress, Grid } from "@mui/material";
import './categoryesView.css';

interface Props {
  navigate?: any;
  params?: any;
  location?: any;
}

interface State {
  categories: Array<Category>;
  loading: boolean;
  showAllCategories: boolean;
}

class CategoriesView extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      loading: true,
      categories: [],
      showAllCategories: false,
    }
  }

  componentDidMount() {
    this.refreshData();
  }

  refreshData = () => {
    this.setState({ loading: true });
    CategoryHandler.getCategories()
      .then((newCategories) => {
        newCategories.sort((a, b) => a.name.localeCompare(b.name));
        this.setState({ categories: newCategories, loading: false });
      })
      .catch(() => this.setState({ loading: false }));
  }

  render() {
    const { loading, categories, showAllCategories } = this.state;

    if (loading) return <CircularProgress />;

    return (
      <div>
        <span className={'caregory-view-title'}>CATALOGO</span>
        {categories.length > 0 ? (
          <div>
            <Grid alignContent={'flex-start'} direction={"row"} className={'caregory-view-container'} justifyContent={'center'} container>
              {categories.map((category, index) => {
                if (showAllCategories || !category.isChildOfAnyCategory) {
                  return (
                    <Link key={'category' + index} to={`/shop/category/${category.externalCategoryId}/page/1`} style={{ margin: '1%' }}>
                      <Card
                        className={'caregory-card'}
                        style={{
                          backgroundImage: category.image?.link ? `url(${category.image.link})` : "",
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "center",
                          backgroundSize: "cover"
                        }}
                      >
                        <div className={'caregory-card-text-container'}>
                          <span className={'caregory-card-text'}>{category.name}</span>
                        </div>
                      </Card>
                    </Link>
                  )
                } else return null;
              })}
            </Grid>
          </div>
        ) : (
          <Grid alignContent={'flex-start'} direction={"row"} className={'caregory-view-container'} justifyContent={'center'} container>
            <div className={'caregory-card-text-container'}>
              <span style={{ color: 'darkgrey' }} className={'caregory-card-text'}>Nessuna Categoria</span>
            </div>
          </Grid>
        )}
      </div>
    );
  }
}

// Wrapper funzionale per passare navigate, params e location
export default function CategoriesViewWrapper(props: any) {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  return <CategoriesView {...props} navigate={navigate} params={params} location={location} />;
}
